import React, { useState,useEffect } from "react";
import Select from "react-select";
import Modal from "react-modal";

const extractYouTubeThumbnail = (videoUrl) => {
  if (!videoUrl) return null;
  const match = videoUrl.match(
    /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/
  );
  return match ? `https://img.youtube.com/vi/${match[1]}/hqdefault.jpg` : null;
};

const MultiSelectExerciseDropdown = ({ exercises, onSelectionChange,resetTrigger }) => {
  const [selectedExercises, setSelectedExercises] = useState([]);
  const [playingVideo, setPlayingVideo] = useState(null);

    // Reset selection when form is saved
    useEffect(() => {
      setSelectedExercises([]);
    }, [resetTrigger]);

  // Format options for react-select
  const options = exercises.map((exercise) => ({
    value: exercise._id,
    label: exercise.title,
    tags: exercise.tags || [],
    thumbnail: extractYouTubeThumbnail(exercise.video_url),
    videoUrl: exercise.video_url,
  }));

  // Custom filtering logic to search by title or tags
  const filterExercises = (inputValue) => {
    return options.filter(
      (exercise) =>
        exercise.label.toLowerCase().includes(inputValue.toLowerCase()) ||
        exercise.tags.some((tag) =>
          tag.toLowerCase().includes(inputValue.toLowerCase())
        )
    );
  };

  // Handle selection change
  const handleChange = (selectedOptions) => {
    setSelectedExercises(selectedOptions || []);
    onSelectionChange(selectedOptions.map((option) => option.value));
  };

  return (
    <div className="p-4 font-inter">
      <h2 className="text-base font-medium mb-2">Select Exercises</h2>

      {/* Custom Dropdown with Thumbnails & Search by Title or Tags */}
      <Select
        isMulti
        options={options}
        value={selectedExercises.length > 0 ? selectedExercises : null} // Ensure it clears properly
        getOptionLabel={(e) => (
          <div className="flex items-center">
            {e.thumbnail ? (
              <img
                src={e.thumbnail}
                alt="Thumbnail"
                className="w-10 h-10 rounded-md mr-2 cursor-pointer"
                onClick={() => setPlayingVideo(e.videoUrl)}
              />
            ) : (
              <span className="w-10 h-10 flex items-center justify-center bg-gray-200 text-xs rounded-md mr-2">
                No Video
              </span>
            )}
            <span>{e.label}</span>
          </div>
        )}
        getOptionValue={(e) => e.value}
        className="w-full"
        onChange={handleChange}
        placeholder="Search by title or tags..."
        filterOption={({ data }, inputValue) =>
          filterExercises(inputValue).some((exercise) => exercise.value === data.value)
        }
      />

      {/* Video Modal */}
      <Modal
        isOpen={!!playingVideo}
        onRequestClose={() => setPlayingVideo(null)}
        className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50"
      >
        <div className="bg-white p-4 rounded-lg w-3/4">
          <button
            className="float-right text-lg font-bold"
            onClick={() => setPlayingVideo(null)}
          >
            ✖
          </button>
          <iframe
            width="100%"
            height="400"
            src={playingVideo?.replace("watch?v=", "embed/")}
            frameBorder="0"
            allow="autoplay; encrypted-media"
            allowFullScreen
            title="Video Player"
          ></iframe>
        </div>
      </Modal>
    </div>
  );
};

export default MultiSelectExerciseDropdown;
